module.exports = __webpack_public_path__ + "38dc8545085e314cddf54823b8bb124f.svg";